import React from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import SectionCTA from "@/components/SectionCTA";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, IMG } from "@/data/site";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <Seo title="Frequently Asked Questions" description="Answers to common questions about tiling costs, bathroom installation, wet rooms, the AI Design Studio and handyman services at Rossi Ceramics." />
      <PageHero eyebrow="Good to know" title="Frequently asked questions" subtitle="Everything you need to know about working with Rossi Ceramics." image={IMG.marble[1]} />

      <section className="container-rossi py-16 max-w-3xl">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="card-lux px-6 border-b-0" data-testid={`faq-${i}`}>
              <AccordionTrigger className="text-left font-serif text-lg text-rossi-cream hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sm text-rossi-cream/75 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <SectionCTA />
    </div>
  );
}
